<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title class="mt-3">
      Ads
      <v-spacer />
      <v-select
        v-model="campaignId"
        clearable
        outlined
        label="Campaign"
        hide-details
        dense
        :items="campaigns"
        class="mr-4"
      />
      <!-- <v-text-field
        v-model="search"
        outlined
        label="Search"
        hide-details
        dense
      /> -->
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          v-for="total in totals"
          :key="total.title"
          cols="12"
          md="2"
        >
          <v-card>
            <v-card-title>{{ total.title }}</v-card-title>
            <v-card-text>{{ total.value }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-text>
      <v-data-table
        :items="itemsToDisplay"
        :headers="headers"
        :search="search"
        :options="{ sortBy: ['updatedDate'], sortDesc: [true] }"
        :footer-props="{
          'items-per-page-options': [100, 250, 500, -1]
        }"
      >
        <template #[`item.isGuest`]="{ item }">
          {{ item.isGuest ? 'X' : '' }}
        </template>
        <template #[`item.totalSpend`]="{ item }">
          {{ item.totalSpend | currency }}
        </template>
        <template #[`item.createdDate`]="{ item }">
          {{ item.createdDate | normalDateWithTime }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { sumBy, uniq } from 'lodash';
export default {
  name: 'AdsView',

  data: () => {
    return {
      search: '',
      headers: [
        { text: 'Email', value: 'email' },
        { text: 'Plan', value: 'plan' },
        { text: 'Status', value: 'planStatus' },
        { text: 'Medium', value: 'utmMedium' },
        { text: 'Source', value: 'utmSource' },
        { text: 'Campaign', value: 'utmCampaign' },
        { text: 'Value', value: 'totalSpend' },
        { text: 'Created', value: 'createdDate' }
      ],
      loading: false,
      campaignId: null
    };
  },

  computed: {
    totals() {
      const list = [
        { title: 'Users', value: this.itemsToDisplay.length },
        { title: 'Guests', value: this.itemsToDisplay.filter((x) => x.isGuest).length },
        {
          title: 'Lifetime Value',
          value: this.$options.filters.currency(sumBy(this.itemsToDisplay, 'totalSpend'))
        }
      ];
      return list;
    },
    campaigns() {
      const items = uniq(this.items.map((x) => x.utmCampaign));
      return items;
    },
    itemsToDisplay() {
      let list = this.items;
      if (this.campaignId) {
        list = list.filter((x) => x.utmCampaign === this.campaignId);
      }
      return list;
    },
    ...mapGetters({
      items: 'reports/ads'
    })
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('reports/getAds')
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
